module.exports ={
    overview: {
        on:'在线',
        off:'离线',
        unit:'个',
        gateway:{
            title:'网关'
        },
        label:{
            title:'标签'
        },
        labelUpdate:{
            title:'更新',
            success: '成功',
            fail: '失败'
        },
        labelBattery:{
            title:'电量',
            normal:'正常',
            exception:'低电量'
        },
        operate:{
            title:'操作',
            updateData:'最近一周标签更新情况',
            unitUpdateSuccess:'更新成功/次',
            unitUpdate:'更新/次',
            updateSuccessRate:'更新成功率',
            updateSuccess:'更新成功',
            updateFail:'更新失败',
            // xTime:['周一','周二','周三','周四','周五','周六','周日']
            xTime:['前天','昨天','今天']
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/common/lang/zh/overview.js